module.exports = __webpack_public_path__ + "img/page-title-bg.226b7db3.jpg";